/* global formatCurrency */
/* global TruTranslations */
/* global Segment */

class PromocodeLookup {

    constructor(plan=undefined, frequency=undefined, order_total=undefined, service_charge_amount=undefined) {
        this.checkoutPlan = plan;
        this.checkoutFrequency = frequency;
        this.order_total = order_total;
        this.service_charge_amount = service_charge_amount;

        this.promo_field = $('input[name=promo_code]')[0];
        this.apply_promo_btn = $('#apply-promo-button');
        this.remove_promo_btn = $('#remove-promo-button');
        this.promo_error = $('#promo-error');


        this.gift_card_field = $('input[name=gift_card]')[0];
        this.apply_gift_card_btn = $('#apply-gift-card-button');
        this.remove_gift_card_btn = $('#remove-gift-card-button');
        this.gift_card_error = $('#gift-card-error');
        this.gift_card_discount_line = $('#gift_card_discount');

        this.applied_gift_card_field = $('input[name=gift_card_code]')[0];

        this.isAlacarte = $('.alacarte');
    }

    transitionState(action, type) {
      let applyBtn = type == 'promo' ? this.apply_promo_btn : this.apply_gift_card_btn;
      let removeBtn = type == 'promo' ? this.remove_promo_btn : this.remove_gift_card_btn;
      let inputField = $(type == 'promo' ? this.promo_field : this.gift_card_field);
      switch (action) {
      case 'apply':
        applyBtn.children(".loading").show();
        applyBtn.children(".label").hide();
        applyBtn.attr('disabled', true);
        removeBtn.hide();
        inputField.attr('disabled', true);
        break;
      case 'applied':
        removeBtn.children(".loading").hide();
        removeBtn.children(".label").show();
        removeBtn.attr('disabled', false);
        removeBtn.show();
        applyBtn.hide();
        break;
      case 'remove':
        removeBtn.children(".loading").show();
        removeBtn.children(".label").hide();
        removeBtn.attr('disabled', true);
        applyBtn.hide();
        break;
      case 'removed':
        applyBtn.children(".loading").hide();
        applyBtn.children(".label").show();
        applyBtn.attr('disabled', false);
        applyBtn.show();
        removeBtn.hide();
        inputField.attr('disabled', false);
        break;
      default:
        console.error('transitionState action:' + action + ", type: " + type);
      }
    }

    applyPromo(csrf_token, apply_promo_url) {
        let promoCode = this.promo_field.value;
        if (!promoCode) return;
        let frequency_id = document.querySelector('.card__frequency__option.active').dataset.frequencyId;

        Segment.promoCodeEntered(promoCode, this.checkoutPlan, this.checkoutFrequency);
        this.transitionState('apply', 'promo');

        var request_data = {csrfmiddlewaretoken: csrf_token, promo_code: promoCode, frequency: frequency_id};
        this.promo_error.hide();
        $.post(apply_promo_url, request_data, (data) => {
            if (data.error) {
                Segment.promoCodeDenied(promoCode, this.checkoutPlan, this.checkoutFrequency, data.error);
                this.promo_error.show();
                this.promo_error.html(data.error);
                this.transitionState('removed', 'promo');
            } else {
                this.transitionState('applied', 'promo');
                Segment.promoCodeApplied(promoCode, this.checkoutPlan, this.checkoutFrequency, data['promo_code']);
                this.refreshSummary(data);
            }
        }, "json").fail(() => {
            this.promo_error.show();
            this.promo_error.html(TruTranslations['checkout_promo_code_error']);
            this.transitionState('removed', 'promo');
        });
    }

    removePromo(csrf_token, remove_promo_url) {
        let promoCode = this.promo_field.value;
        if (!promoCode) return;

        this.transitionState('remove', 'promo');

        var request_data = {csrfmiddlewaretoken: csrf_token};
        this.promo_error.hide();
        $.post(remove_promo_url, request_data, (data) => {
            if (data.error) {
                this.promo_error.show();
                this.promo_error.html(TruTranslations['checkout_error_removing_code']);
                this.transitionState('applied', 'promo');
            } else {
                this.transitionState('removed', 'promo');
                Segment.promoCodeRemoved(promoCode, this.checkoutPlan, this.checkoutFrequency);
                this.refreshSummary(data);
            }
        }, "json").fail(() => {
            this.promo_error.show();
            this.promo_error.html(TruTranslations['checkout_error_removing_code']);
            this.transitionState('applied', 'promo');
        });
    }

    applyGiftCard(csrf_token, apply_gift_card_url) {
        let giftCard = this.gift_card_field.value;
        if (!giftCard) return;

        Segment.promoCodeEntered(giftCard, this.checkoutPlan, this.checkoutFrequency);
        this.transitionState('apply', 'gc');

        var request_data = {csrfmiddlewaretoken: csrf_token, gift_card: giftCard, order_total:this.order_total };
        this.gift_card_error.hide();

        $.post(apply_gift_card_url, request_data, (data) => {
            if (data.error) {
                Segment.promoCodeDenied(giftCard, this.checkoutPlan, this.checkoutFrequency, data.error);
                this.gift_card_error.show();
                this.gift_card_error.html(data.error);
                this.transitionState('removed', 'gc');
            } else {
                this.transitionState('applied', 'gc');
                Segment.promoCodeApplied(giftCard, this.checkoutPlan, this.checkoutFrequency, data['gift_card']);
                this.refreshSummary(data);
            }
        }, "json").fail(() => {
            this.gift_card_error.show();
            this.gift_card_error.html(TruTranslations['gift_card_error_general']);
            this.transitionState('removed', 'gc');
        });
    }

    removeGiftCard(csrf_token, remove_gift_card_url, one_off=false) {
        let giftCard = this.gift_card_field.value;
        if (!giftCard) return;

        this.transitionState('remove', 'gc');

        var request_data = {csrfmiddlewaretoken: csrf_token};
        this.gift_card_error.hide();

        if (!one_off) {
            $.post(remove_gift_card_url, request_data, (data) => {
                if (data.error) {
                    this.gift_card_error.show();
                    this.gift_card_error.html(TruTranslations['checkout_error_removing_gift_card']);
                    this.transitionState('applied', 'gc');
                } else {
                    this.transitionState('removed', 'gc');
                    Segment.promoCodeRemoved(giftCard, this.checkoutPlan, this.checkoutFrequency);
                    this.refreshSummary(data);
                }
            }, "json").fail(() => {
                this.gift_card_error.show();
                this.gift_card_error.html(TruTranslations['checkout_error_removing_gift_card']);
                this.transitionState('applied', 'gc');
            });
        } else {
            let data = {
                promo_discount: 0,
                order_total: this.order_total,
                service_charge_amount: this.service_charge_amount,
                promo_products: undefined,
                gift_card_discount: 0,
            }
            this.transitionState('removed', 'gc');
            Segment.promoCodeRemoved(giftCard, this.checkoutPlan, this.checkoutFrequency);
            this.refreshSummary(data);
        }
    }

    refreshSummary(data) {
        // Display promo code discount
        let discount_line = $('#promo_discount');
        if (data.promo_discount === 0) {
            discount_line.addClass('hidden');
        }
        else {
            discount_line.removeClass('hidden');
            $($('#discount_amount')[0]).text(formatCurrency(data.promo_discount));
        }

        // Display promo code products
        let promo_products = $('#promo-products');
        // Empty promo products list
        promo_products.html("");

        if (data.promo_products) {
            let pr, pm, imgUrl, name, promoCodeName, quantifiedPkgDesc;
            let productRow = $($(".product_row_entry")[0]);
            let productModal = $($(".build__product-info")[0]);
            for (let i = 0; i < data.promo_products.length; i++) {
                // Clone template product
                pr = productRow.clone();
                pm = productModal.clone();

                imgUrl = data.promo_products[i].product.thumbnail_url;
                name = data.promo_products[i].product.name;
                promoCodeName = data.promo_code.toUpperCase() + ': ' + name
                quantifiedPkgDesc = data.promo_products[i].quantified_package_description;

                // Product row fields
                let prIcon = pr.find('.icon');
                prIcon.attr("src", imgUrl + "?fit=crop&w=172&h=172");
                prIcon.attr("alt", name);
                $('.quantity-bubble', pr).html("");
                $('.name', pr).html(promoCodeName);
                $('.points, .price', pr).html(TruTranslations['free']);
                $('.quantity, .summation', pr).text(quantifiedPkgDesc);

                // Product modal fields
                let pmThumbnail = pm.find('.thumbnail');
                pmThumbnail.attr("src", imgUrl + "?fit=crop&w=256&h=256");
                pmThumbnail.attr("alt", name);
                $('.title', pm).html(promoCodeName);
                $('.summation', pm).text(quantifiedPkgDesc);
                $('.weight-range', pm).text(data.promo_products[i].product.weight_range);
                $('.point-value', pm).html(TruTranslations['free']);
                $('.description', pm).html(data.promo_products[i].product.description);
                $('.nutrition', pm).html(data.promo_products[i].product.nutrition);
                $('.ingredients', pm).html(data.promo_products[i].product.ingredients);

                // append promo product to container
                promo_products.append(pr);
                promo_products.append(pm);
            }
        }

        if (data.gift_card_discount != 0) {
            document.getElementById('gift_card_discount').style.display = 'flex';
            $('#gift_card_amount').text(formatCurrency(data.gift_card_discount));
            if (this.applied_gift_card_field) {
                this.applied_gift_card_field.value = this.gift_card_field.value;
            }
        } else {
            this.gift_card_discount_line.hide();
            if (this.applied_gift_card_field) {
                this.applied_gift_card_field.value = ''
            }
        }

        $($('#total_amount')[0]).text(formatCurrency(data.order_total));
        $($('#service_charge_amount')[0]).text(formatCurrency(data.service_charge_amount));
        if (data.service_charge_amount > 0) {
            $('#service_charge_line').removeClass('hidden');
        } else {
            $('#service_charge_line').addClass('hidden');
        }
        if (this.checkoutPlan === undefined) {
            if (data.order_total == '0.00') {
                $('#credit-card').hide();
            } else {
                $('#credit-card').show();
            }
        }
    }
}

export default PromocodeLookup;
